"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderHistoryList = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var styled_components_1 = require("styled-components");
var HiArrowRight_1 = require("@react-icons/all-files/hi/HiArrowRight");
var react_1 = require("react");
var react_virtualized_auto_sizer_1 = __importDefault(require("react-virtualized-auto-sizer"));
var react_window_1 = require("react-window");
var context_1 = require("../../context/context");
var hooks_1 = require("../../hooks");
var orders_1 = require("../../hooks/orders");
var styles_1 = require("../../styles");
var base_1 = require("../base");
var context_2 = require("./context");
var React = __importStar(require("react"));
var utils_1 = require("../../utils");
var OrderHistoryList = function () {
    var _a = (0, context_2.useOrderHistoryContext)(), selectOrder = _a.selectOrder, orders = _a.orders, selectedOrderId = _a.selectedOrderId, isLoading = _a.isLoading;
    var sizeMap = (0, react_1.useRef)({});
    var listRef = (0, react_1.useRef)();
    var setSize = (0, react_1.useCallback)(function (index, size) {
        var _a;
        sizeMap.current = __assign(__assign({}, sizeMap.current), (_a = {}, _a[index] = size, _a));
        listRef.current.resetAfterIndex(0);
    }, []);
    var getSize = (0, react_1.useCallback)(function (index) {
        return sizeMap.current[index] || 50;
    }, []);
    if (isLoading) {
        return (0, jsx_runtime_1.jsx)(StyledLoader, { height: 120 });
    }
    if (!(0, utils_1.size)(orders)) {
        return (0, jsx_runtime_1.jsx)(EmptyList, {});
    }
    return ((0, jsx_runtime_1.jsx)(ListContainer, __assign({ style: { opacity: selectedOrderId ? 0 : 1, pointerEvents: selectedOrderId ? "none" : "all" }, className: "twap-orders-list" }, { children: (0, jsx_runtime_1.jsx)(react_virtualized_auto_sizer_1.default, { children: function (_a) {
                var height = _a.height, width = _a.width;
                return ((0, jsx_runtime_1.jsx)(react_window_1.VariableSizeList, __assign({ ref: listRef, height: height, itemCount: (0, utils_1.size)(orders), itemSize: getSize, width: width, itemData: { setSize: setSize, selectOrder: selectOrder, orders: orders } }, { children: Comp })));
            } }) })));
};
exports.OrderHistoryList = OrderHistoryList;
var Comp = function (props) {
    var style = props.style, data = props.data, index = props.index;
    var selectOrder = data.selectOrder, setSize = data.setSize, orders = data.orders;
    return ((0, jsx_runtime_1.jsx)("div", __assign({ style: style }, { children: (0, jsx_runtime_1.jsx)(ListOrder, { onSelect: selectOrder, setSize: setSize, index: index, order: orders[index] }) })));
};
var EmptyList = function () {
    var tab = (0, context_2.useOrderHistoryContext)().selectedTab;
    var name = React.useMemo(function () {
        if ((tab === null || tab === void 0 ? void 0 : tab.name) === "All") {
            return "";
        }
        return tab === null || tab === void 0 ? void 0 : tab.name;
    }, [tab]);
    return ((0, jsx_runtime_1.jsx)(StyledEmpty, { children: (0, jsx_runtime_1.jsxs)(styles_1.StyledText, { children: ["No ", name, " Orders"] }) }));
};
var ListContainer = (0, styled_components_1.styled)(styles_1.StyledColumnFlex)({
    width: "100%",
    height: "calc(100% - 50px)",
    top: 50,
    position: "absolute",
    zIndex: 1,
    "*::-webkit-scrollbar": {
        display: "none",
    },
});
var StyledLoader = (0, styled_components_1.styled)(base_1.Loader)({
    borderRadius: 15,
    transformOrigin: "top",
});
var StyledEmpty = (0, styled_components_1.styled)(styles_1.StyledColumnFlex)({
    alignItems: "center",
    justifyContent: "flex-start",
    paddingTop: 30,
    paddingBottom: 30,
    fontSize: 18,
    fontWeight: 500,
});
var ListOrder = React.memo(function (_a) {
    var parsedOrder = _a.order, index = _a.index, setSize = _a.setSize, onSelect = _a.onSelect;
    var order = (0, orders_1.useParseOrderUi)(parsedOrder);
    var root = (0, react_1.useRef)();
    (0, react_1.useEffect)(function () {
        setSize(index, root.current.getBoundingClientRect().height);
    }, [index]);
    if (!order)
        return null;
    return ((0, jsx_runtime_1.jsx)(Wrapper, __assign({ className: "twap-order", ref: root, onClick: function () { return onSelect(parsedOrder === null || parsedOrder === void 0 ? void 0 : parsedOrder.id); } }, { children: (0, jsx_runtime_1.jsxs)(StyledListOrder, __assign({ className: "twap-order-container" }, { children: [(0, jsx_runtime_1.jsx)(ListItemHeader, { order: order }), (0, jsx_runtime_1.jsx)(LinearProgressWithLabel, { value: order.progress || 0 }), (0, jsx_runtime_1.jsxs)(styles_1.StyledRowFlex, __assign({ className: "twap-order-tokens" }, { children: [(0, jsx_runtime_1.jsx)(TokenDisplay, { token: order.srcToken }), (0, jsx_runtime_1.jsx)(HiArrowRight_1.HiArrowRight, { className: "twap-order-tokens-arrow" }), (0, jsx_runtime_1.jsx)(TokenDisplay, { token: order.dstToken })] }))] })) })));
});
var ListItemHeader = function (_a) {
    var order = _a.order;
    var t = (0, context_1.useTwapContext)().translations;
    var status = order && t[order.status];
    return ((0, jsx_runtime_1.jsxs)(StyledHeader, __assign({ className: "twap-order-header" }, { children: [(0, jsx_runtime_1.jsxs)(styles_1.StyledText, __assign({ className: "twap-order-header-text" }, { children: [" ", "#", order === null || order === void 0 ? void 0 : order.id, " ", (order === null || order === void 0 ? void 0 : order.isMarketOrder) ? t.twapMarket : t.limit, " ", (0, jsx_runtime_1.jsx)("span", { children: "(".concat(order === null || order === void 0 ? void 0 : order.createdAtUi, ")") })] })), (0, jsx_runtime_1.jsx)(styles_1.StyledText, __assign({ className: "twap-order-header-status" }, { children: status }))] })));
};
var StyledHeader = (0, styled_components_1.styled)(styles_1.StyledRowFlex)({
    justifyContent: "space-between",
    fontSize: 14,
    ".twap-order-header-text": {
        textTransform: "capitalize",
        span: {
            fontSize: 12,
            opacity: 0.7,
        },
    },
    ".twap-order-header-status": {
        fontSize: 12,
        opacity: 0.7,
    },
    "@media(max-width: 1000px)": {
        fontSize: 12,
    },
});
var Wrapper = (0, styled_components_1.styled)(styles_1.StyledColumnFlex)({
    padding: "0px 0px 10px 0px",
});
var StyledListOrder = (0, styled_components_1.styled)(styles_1.StyledColumnFlex)({
    borderRadius: 15,
    padding: 10,
    gap: 5,
    cursor: "pointer",
    ".twap-order-tokens": {
        justifyContent: "flex-start",
    },
    ".twap-order-tokens-arrow": {
        width: 16,
        height: 16,
    },
    ".twap-token-logo": {
        width: 16,
        height: 16,
    },
});
var TokenDisplay = function (_a) {
    var token = _a.token, amount = _a.amount;
    var _amount = (0, hooks_1.useFormatNumberV2)({ value: amount, decimalScale: 4 });
    return ((0, jsx_runtime_1.jsxs)(StyledTokenDisplay, __assign({ className: "twap-order-token" }, { children: [(0, jsx_runtime_1.jsx)(base_1.TokenLogo, { logo: token === null || token === void 0 ? void 0 : token.logoUrl }), (0, jsx_runtime_1.jsxs)(styles_1.StyledText, __assign({ className: "twap-order-token-text" }, { children: [_amount, " ", token === null || token === void 0 ? void 0 : token.symbol] }))] })));
};
var StyledTokenDisplay = (0, styled_components_1.styled)(styles_1.StyledRowFlex)({
    width: "auto",
    ".twap-order-token-text": {
        fontSize: 14,
        opacity: 0.8,
    },
    "@media(max-width: 1000px)": {
        ".twap-order-token-text": {
            fontSize: 12,
        },
    },
});
function LinearProgressWithLabel(props) {
    return ((0, jsx_runtime_1.jsxs)(StyledProgress, __assign({ className: "twap-order-token-progress" }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ style: { width: "100%" } }, { children: (0, jsx_runtime_1.jsx)(base_1.LinearProgress, __assign({ variant: "determinate" }, props)) })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "twap-order-token-progress-label" }, { children: (0, jsx_runtime_1.jsx)(styles_1.StyledText, { children: "".concat(Math.round(props.value), "%") }) }))] })));
}
var StyledProgress = (0, styled_components_1.styled)(styles_1.StyledRowFlex)({
    width: "100%",
    gap: 0,
    p: {
        fontSize: 12,
        opacity: 0.8,
        textAlign: "right",
    },
    ".twap-order-token-progress-label": {
        minWidth: 40,
    },
});
